import { render, staticRenderFns } from "./PromoCustomer.vue?vue&type=template&id=bfaa77d6&"
import script from "./PromoCustomer.vue?vue&type=script&lang=js&"
export * from "./PromoCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports